import debounce from 'lodash.debounce';
import { useLayoutEffect } from 'react';
import { useInstantSearch } from 'react-instantsearch-hooks-web';

function middleware() {
	const sendEventDebounced = debounce(() => {
		if ( ! window.ga ) {
			return;
		}
		window.ga( 'set', 'page', window.location.pathname + window.location.search );
		window.ga( 'send', 'pageView' );
	}, 3000 );

	return {
		onStateChange( { uiState } ) {
			sendEventDebounced( uiState );
		},
		subscribe() {},
		unsubscribe() {},
	};
}

function GoogleAnalyticsMiddleware() {
	const { use } = useInstantSearch();

	useLayoutEffect( () => {
		return use( middleware );
	}, [use] );

	return null;
}

export default GoogleAnalyticsMiddleware;
